import { CloudDownload, Loader2 } from "lucide-react";
import { useSatDownloadJobsOptional } from "@/lib/satDownloadJobs";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * Indicador discreto de descargas SAT en segundo plano (barra de módulo).
 */
export default function SatDownloadJobsIndicator() {
  const ctx = useSatDownloadJobsOptional();
  const count = ctx?.activeCount ?? 0;
  const jobs = ctx?.activeJobs ?? [];

  if (!count) return null;

  const primary = jobs[0];
  const pct = Math.min(100, Math.max(0, Number(primary?.progress?.percent) || 0));
  const msg = primary?.progress?.message || "Descargando CFDI del SAT…";
  const statusLabel = primary?.statusLine?.label || "";

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="inline-flex flex-col gap-1 rounded-sm border border-sky-200 bg-sky-50 px-2.5 py-1.5 min-w-[7.5rem] text-[11px] font-medium text-sky-950"
            data-testid="sat-download-jobs-indicator"
            role="status"
            aria-live="polite"
            aria-valuenow={pct}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="inline-flex items-center gap-2">
              <Loader2 className="h-3.5 w-3.5 animate-spin text-sky-700 shrink-0" />
              <CloudDownload className="h-3.5 w-3.5 text-sky-800 shrink-0 hidden sm:block" />
              <span className="whitespace-nowrap tabular-nums">
                SAT {count > 1 ? `(${count})` : ""} · {pct}%
              </span>
            </div>
            <div
              className="h-1 rounded-full bg-sky-100 overflow-hidden"
              aria-hidden="true"
            >
              <div
                className="h-full bg-sky-600 transition-all duration-500"
                style={{ width: `${pct}%` }}
              />
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-sm text-xs">
          <p className="font-semibold m-0">Descarga en segundo plano</p>
          {statusLabel ? (
            <p className="m-0 mt-1 font-medium text-sky-900">{statusLabel}</p>
          ) : null}
          <p className="m-0 mt-1 opacity-90">{msg}</p>
          <p className="m-0 mt-1 text-[10px] opacity-75">
            Puede cambiar de pantalla; el proceso continúa en el servidor.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
